
import React, { useContext, useState } from 'react'

import { SessionContext } from './SessionProvider'

const TemplatesContext = React.createContext()
const { Provider } = TemplatesContext

const defaultTemplatesState =
{
	pagingRequest:
	{
		pageIndex: 0,
		pageSize: 15
	},
	auctionTemplate:
	{
		adminAuctionId: 0,
		name: '',
		createdByUserId: 0,
		createdDate: undefined,
		userName: '',
		defaultForTypeId: 1,
		defaultForEntityId: undefined,
		auctionTemplateTiers: [],
		disabled: false
	}
}

const TemplatesProvider = props =>
{
	const { sessionContext } = useContext(SessionContext);

	const [pagingRequest, setPagingRequest] = useState(defaultTemplatesState.pagingRequest)
	const [auctionTemplate, setAuctionTemplate] = useState(defaultTemplatesState.auctionTemplate)
	const [auctionTemplateTiers, setAuctionTemplateTiers] = useState(defaultTemplatesState.auctionTemplate.auctionTemplateTiers)

	return <Provider value={{
		pagingRequest,
		setPagingRequest,
		auctionTemplate,
		setAuctionTemplate,
		auctionTemplateTiers,
		setAuctionTemplateTiers
	}}>{ props.children }</Provider>
}

export { TemplatesProvider, TemplatesContext }
